var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCodeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.6667V0H11.6667V11.6667H0ZM2.91667 8.75H8.75V2.91667H2.91667V8.75ZM0 26.25V14.5833H11.6667V26.25H0ZM2.91667 23.3333H8.75V17.5H2.91667V23.3333ZM14.5833 11.6667V0H26.25V11.6667H14.5833ZM17.5 8.75H23.3333V2.91667H17.5V8.75ZM23.3333 26.25V23.3333H26.25V26.25H23.3333ZM14.5833 17.5V14.5833H17.5V17.5H14.5833ZM17.5 20.4167V17.5H20.4167V20.4167H17.5ZM14.5833 23.3333V20.4167H17.5V23.3333H14.5833ZM17.5 26.25V23.3333H20.4167V26.25H17.5ZM20.4167 23.3333V20.4167H23.3333V23.3333H20.4167ZM20.4167 17.5V14.5833H23.3333V17.5H20.4167ZM23.3333 20.4167V17.5H26.25V20.4167H23.3333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeIcon);
export default __webpack_public_path__ + "static/media/qrCodeIcon.c527d1457cfc507d031c5a073d84450c.svg";
export { ForwardRef as ReactComponent };